import { Edit, VerifiedUser } from '@mui/icons-material'
import { Box, Button, SelectChangeEvent } from '@mui/material'
import { PLAN_ACCESS_OPTIONS } from 'Common/Constants/Constants'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ScenarioPlanViewProps } from './ScenarioPlan.type'
import { OperationalPlannerMUITable } from './OperationalPlanner.MUITable'
import { PlanTableRow } from './OperationalPlanner.types'
import { useOperationalPlan } from './OperationalPlan.data'
import { generatedBySelect } from 'Common/utils/utils'
import { PlanAccessSelect } from 'Common/Components/PlanView.components'
import { ShowPlansOptionType } from 'Common/Components/Common.types'

export const OperationalPlanView = ({
  handleRowClick,
  handleRenamePlan,
  handleDeletePlan,
  handleClonePlan,
  handleEditPlan,
  handleRunPlan,
  handleDownloadPlan,
  handlePlanAccessChange,
  userEmail,
}: ScenarioPlanViewProps) => {
  const navigate = useNavigate()
  const [showPlansOption, setShowPlansOption] = useState(
    PLAN_ACCESS_OPTIONS['Generated by me'] as ShowPlansOptionType
  )
  const [operationalPlanTableData, setOperationalPlanTableData] = useState<
    PlanTableRow[]
  >([])

  const handleShowMyPlansDropdown = (event: SelectChangeEvent<string>) => {
    const { value } = event.target
    setShowPlansOption(value as ShowPlansOptionType)
  }

  const { data, isLoading: isOperationalPlansLoading } =
    useOperationalPlan('operational-plans')

  const { operationalPlanData } = data ?? {}

  useEffect(() => {
    if (operationalPlanData && operationalPlanData?.length > 0) {
      generatedBySelect(
        showPlansOption,
        operationalPlanData,
        userEmail,
        setOperationalPlanTableData
      )
    }
  }, [showPlansOption, operationalPlanData])

  const createPlan = () => {
    navigate('/create-plan')
  }

  const handleCheckDataClick = () => {
    navigate('/quality-check')
  }

  return (
    <Box>
      <Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          id="operational-plan-view"
        >
          <Box display="flex" alignItems="center">
            <PlanAccessSelect
              showPlansOption={showPlansOption}
              handleShowMyPlansDropdown={handleShowMyPlansDropdown}
            />
          </Box>
          <Box display="flex">
            <Button
              onClick={handleCheckDataClick}
              color="primary"
              variant="outlined"
              startIcon={<VerifiedUser />}
              sx={{
                color: '#00415A',
                border: '1px solid rgba(0, 65, 90, 0.5)',
                textTransform: 'none',
              }}
            >
              <Box
                sx={{
                  fontWeight: 700,
                  fontSize: '1rem',
                }}
              >
                Check data
              </Box>
            </Button>
            <Box marginLeft={2}></Box>
            <Button
              onClick={createPlan}
              color="primary"
              variant="outlined"
              startIcon={<Edit />}
              sx={{
                color: '#00415A',
                border: '1px solid rgba(0, 65, 90, 0.5)',
                textTransform: 'none',
              }}
            >
              <Box
                sx={{
                  fontWeight: 700,
                  fontSize: '1rem',
                }}
              >
                Create plan
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>
      <Box marginTop={2}>
        <OperationalPlannerMUITable
          key="operational-plan-table"
          handleRowClick={handleRowClick}
          handleRenamePlan={handleRenamePlan}
          handleDeletePlan={handleDeletePlan}
          handleClonePlan={handleClonePlan}
          handleEditPlan={handleEditPlan}
          handleRunPlan={handleRunPlan}
          handleDownloadPlan={handleDownloadPlan}
          handlePlanAccessChange={handlePlanAccessChange}
          userEmail={userEmail}
          data={operationalPlanTableData}
          isLoading={isOperationalPlansLoading}
        />
      </Box>
    </Box>
  )
}
